import aa from 'search-insights';
import algoliaConfig from '../../main/algolia-config';
import {authApi} from '../apis/auth';

const state = {
  status: null,
  access_token: null,
  refresh_token: null,
  user: null,
  newRegistration: false
};

const getters = {
  access_token: state => state.access_token,
  refresh_token: state => state.refresh_token,
  user: state => state.user,
  authenticated(state) {
    return Boolean(
      state.status === 'success'
      && state.access_token
      && state.refresh_token
      && state.user
    );
  }
};

const actions = {
  async getCurrentUser({commit}) {
    try {
      const res = await authApi.getCurrentUser();
      commit('auth_update_user', res.data);
      return res;
    } catch (e) {
      commit('auth_error', e);
    }
  },
  async login({commit}, data) {
    try {
      const res = await authApi.login(data);

      aa('init', {
        appId: algoliaConfig.appId,
        apiKey: algoliaConfig.apiKey,
        userToken: res?.user?.customerId,
        authenticatedUserToken: res?.user?.customerId
      });

      commit('auth_success', res);
      return res;
    } catch (e) {
      commit('auth_error', e);
      throw e;
    }
  },
  async register({commit}, data) {
    try {
      const res = await authApi.register(data);
      commit('auth_success', res);
      return res;
    } catch (e) {
      commit('auth_error', e);
      throw e;
    }
  },
  async logout({getters, commit}, reason) {
    if (getters.access_token && getters.refresh_token) {
      authApi.logout(getters.access_token, getters.refresh_token);
    }
    commit('marketplace/reset_all_data', [], {root: true});
    commit('designspec/setProjects', [], {root: true});
    commit('auth_logout', reason);
  },
  async forgotPassword({}, data) {
    return await authApi.forgotPassword(data);
  },
  async refreshToken({getters, dispatch, commit}) {
    const res = await authApi.refreshToken(getters.refresh_token);
    commit('auth_success', {...res, user: getters.user});
    dispatch('getCurrentUser');
    return res;
  }
};

const mutations = {
  auth_update_user(state, user) {
    state.user = user;
  },
  auth_reset_new_registration(state) {
    state.newRegistration = false;
  },
  auth_success(state, {access_token, refresh_token, user, newRegistration = false}) {
    state.status = 'success';
    state.access_token = access_token;
    state.refresh_token = refresh_token;
    state.user = user;
    state.newRegistration = newRegistration;
  },
  auth_refresh_token_failed(state) {
    state.status = 'refresh_token_failed';
    state.access_token = null;
    state.refresh_token = null;
    state.user = null;
    state.newRegistration = false;
  },
  auth_error(state) {
    state.status = 'error';
    state.access_token = null;
    state.refresh_token = null;
    state.user = null;
    state.newRegistration = false;
  },
  auth_logout(state, reason = '') {
    state.status = reason;
    state.access_token = null;
    state.refresh_token = null;
    state.user = null;
    state.newRegistration = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
